export enum BrandColor {
  Blue = '#275879',
  BlueLight = '#E3F5F8',
  Brown = '#926836',
  BrownDark = '#6F4613',
  BrownLight = '#FFF6E6',
  Purple = '#5C1697',
}

// We used class rather than enums since enums don't support computed values
export class Color {
  public static readonly Black = '#000B0F';
  public static readonly White = 'white';

  public static readonly GrayXLight = '#F1F1F1';
  public static readonly GrayLight = '#E5E6E7';
  public static readonly Gray = '#999D9F';
  public static readonly GrayDark = '#52595C';
  public static readonly GrayXDark = '#333C3F';

  public static readonly PrimaryLight = BrandColor.BrownLight;
  public static readonly Primary = BrandColor.Brown;
  public static readonly PrimaryDark = BrandColor.BrownDark;
  public static readonly Secondary = Color.Black;
  public static readonly Accessory = BrandColor.Purple;
  public static readonly Neutral = Color.GrayDark;
  public static readonly CallToAction = BrandColor.Blue;
  public static readonly CallToActionSecondary = BrandColor.BlueLight;

  public static readonly Alert = '#DC3E51';
  public static readonly Warning = '#FF6E46';
  public static readonly Success = '#00C1A2';
}

export enum FontFamily {
  Primary = 'Raleway',
  Secondary = 'WorkSans',
}

export enum FontWeight {
  Normal = 'normal',
  Medium = 600,
  Bold = 'bold',
}

export enum FontSize {
  XSmall = '12px',
  Small = '14px',
  Medium = '16px',
  Large = '18px',
  XLarge = '24px',
}

export enum Spacing {
  XSmall = '4px',
  Small = '8px',
  Medium = '16px',
  Large = '24px',
  XLarge = '32px',
}

export const HeaderHeight = {
  Mobile: '64px',
  Desk: '80px',
};

export enum IconSize {
  Small = '12px',
  Medium = '16px',
  Large = '20px',
}

export enum FaIconSize {
  XSmall = 'xs',
  Large = 'lg',
  Small = 'sm',
  X1 = '1x',
  X2 = '2x',
  X3 = '3x',
  X4 = '4x',
  X5 = '5x',
  X6 = '6x',
  X7 = '7x',
  X8 = '8x',
  X9 = '9x',
  X10 = '10x',
}

export const DrawerWidth = '256px';

export const Navbar = {
  a: '1',
};

export const FieldHeight = '48px';
export const TransitionDuration = '.3s';

export const Border = {
  Color: Color.GrayDark,
  Width: '1px',
  Radius: '4px',
  RadiusLarge: '24px',
};

// Security recommendation: Failing to enforce passwords of at least 7 characters, a complexity
// of at least alpha and numeric characters increases the risk of a brute force attack.
export enum PasswordLength {
  Max = 18,
  Min = 7,
}

export enum AspectRatio {
  Square = 1,
}

export const Breakpoint = {
  xs: 0, // em
  sm: 32, // em
  md: 48, // em
  lg: 64, // em
};

export enum ZIndex {
  ground = 0,
  first = 1,
  second = 2,
  third = 3,
  top = 4,
}

export const Shadow = {
  Small: '0px 2px 2px 0px rgba(0,0,0,0.2)',
};
